import React from 'react';
import type { JobAd } from '../../../types';
import type { AdImageProps } from '../../ad/AdImage';
import { AdImage } from '../../ad/AdImage';

const logoStyle: React.CSSProperties = {
    maxWidth: '65%',
    maxHeight: '65%',
};

type JobImageProps = {
    ad: JobAd;
    aspectClass: string;
    image?: (props: AdImageProps) => React.ReactElement | null;
    imageClass: string;
};

export function JobImage(props: JobImageProps) {
    const { ad, aspectClass, image, imageClass } = props;

    const imageProps = {
        aspectClass,
        imageClass,
    };

    return image ? (
        image(imageProps)
    ) : (
        <AdImage {...imageProps} {...ad.image}>
            {({ className, src }) => (
                <img alt="" className={className} src={src} style={logoStyle} />
            )}
        </AdImage>
    );
}
